import { render, staticRenderFns } from "./PoiCardContent.vue?vue&type=template&id=01612203&"
import script from "./PoiCardContent.vue?vue&type=script&lang=ts&"
export * from "./PoiCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports